import React, { useEffect, useState } from 'react'
import SideBarBack from '../../components/SidebarBack'
import { useDispatch } from 'react-redux'
import {
    setDrawerActiveMenu
} from '../../store/features/webUtilitiesSlice'
import allergies from '../../assets/images/allergies/allergies.png'

import Popup from 'reactjs-popup'
import 'reactjs-popup/dist/index.css'

const menuOption = [
    {
        name: "Apple health",
        key: 1,
        subtitle: "Link the FastBetter app with apple health",
        isLinked: false,
    },
]

export default function Menu() {
    const dispatch = useDispatch()
    const handleCloseDrawer = async () => {
        await dispatch(setDrawerActiveMenu(31))
    }

    const hanldeClose = async () => {
        setIsPopupOpen(false)
    }
    const [isPopupOpen, setIsPopupOpen] = useState(false)

    return (
        <div className='w-full h-full' >
            <div className='w-full flex mb-2'>
                <SideBarBack className="bg-transparent" handleCloseDrawer={handleCloseDrawer} />
            </div>
            <div className='flex flex-col gap-2 mt-28 w-11/12 mx-auto pb-14'>
                <div className='cardbox w-full border border-gray-200 shadow-md py-5 px-4 rounded-3xl'>
                    <div className='mode1'>
                        <img
                            className='watchImg w-24 h-24 rounded-md'
                            alt='watchImg'
                            src={allergies}
                        />
                        <div>
                            <p className='cardboxtitle text-sm'>
                                Any ingredient allergies?
                            </p>
                            <p className='text-[11px]'>
                                Get meals tailored to your needs and preferences.
                            </p>
                        </div>
                    </div>
                </div>

            </div>
            <PopUpModel isPopupOpen={isPopupOpen} hanldeClose={hanldeClose} deviceKey={1} />
        </div>
    )
}

const PopUpModel = ({ isPopupOpen, hanldeClose, deviceKey }) => {

    const [deviceData, setDeviceData] = useState(null);
    const [islinked, setIslinked] = useState(false);
    const [nextProcessSuccess, setNextProcessSuccess] = useState(true);

    useEffect(() => {
        const selectedDevice = menuOption.find(device => device.key === deviceKey);
        setDeviceData(selectedDevice);
        setIslinked(selectedDevice?.isLinked)
    }, [deviceKey, menuOption]);

    const hanldeClickToAction = async () => {
        setNextProcessSuccess(false)
        if (!nextProcessSuccess && !islinked) {
            setNextProcessSuccess(true)
            setIslinked(true)
        }
    }

    return (
        <Popup
            open={isPopupOpen}
            position='center'
            className='pop-width-link'
            onClose={() => hanldeClose()}
        >
            <div className='w-32 h-32 -z-10 -top-2 right-36 absolute bg-white rounded-full '></div>
            <div className='text-center z-10 relative py-5 pb-8 px-5'>
                {deviceData && (
                    <div className='text-center'>

                    </div>
                )}
            </div>
        </Popup>
    )
}